import { Empty, Popover } from 'antd'
import Button from 'components/Button/index'
import Flex from 'components/Flex'
import Input from 'components/Form/Input'
import { CopyLinkDiv } from 'components/UIComponents/FormStyles'
import Uploader from 'components/Uploader/Uploader'
import AddBlueIcon from 'components/icons/AddBlueIcon'
import ErrorIcon from 'components/icons/ErrorIcon'
import EyeIcon from 'components/icons/EyeIcon'
import LinkIcon from 'components/icons/LinkIcon'
import UploadIcon from 'components/icons/UploadIcon'
import AddMediaLinksDrawer from 'modules/Settings/Components/AddtionalInfo/AddMediaLinksDrawer'
import {
  AddLinkspan,
  AddMediaButton,
  ComanyDiv,
  Container,
  Divider,
  DocumentFlex,
  FileInfoLi,
  ImageSpan,
  NoDataDiv,
  PopoverImg,
  PreviewDiv,
} from 'modules/Settings/Components/AddtionalInfo/style'
import {
  CommonFlex,
  RightSection,
  SubTitleDiv,
} from 'modules/Settings/Components/CompanyInfo/style'
import { MainWrapper } from 'modules/Settings/Styles/style'
import React, { useState } from 'react'
import { copyText } from 'utils/copyText'
import { getYear } from 'utils/getYear'
import { ULTagElement } from './style'

const AddtionalInfo = ({
  corporateData,
  socialMediaList,
  setSocialMediaList,
  presentationFile,
  setPresentationFile,
  onChangeFormFields,
  settingsForm,
}) => {
  const [addMediaDrawer, setAddMediaDrawer] = useState(false)

  const onLinkChange = (linkValue, updateIndex) => {
    const updatedData = socialMediaList?.map((item, index) => {
      if (index == updateIndex) {
        return {
          ...item,
          link: linkValue,
        }
      } else {
        return item
      }
    })
    setSocialMediaList(updatedData)
    onChangeFormFields()
  }
  const mediaOptions = [
    {
      name: 'Facebook',
      value: 'Facebook',
    },
    {
      name: 'Instagram',
      value: 'Instagram',
    },
    {
      name: 'Linkedin',
      value: 'Linkedin',
    },
    {
      name: 'Twitter',
      value: 'Twitter',
    },
  ]

  return (
    <>
      <Container>
        <MainWrapper>
          <Flex centerVertically>
            <ComanyDiv>
              Company Additinal Info
              {!presentationFile && (
                <ImageSpan>
                  <ErrorIcon />
                </ImageSpan>
              )}
            </ComanyDiv>
          </Flex>
          <CommonFlex spaceBetween>
            <div>
              <SubTitleDiv>Corporate Presentation</SubTitleDiv>
              <Flex column>
                <ULTagElement>
                  <FileInfoLi>Max size: 2 MB</FileInfoLi>
                  <FileInfoLi>Supported format : pdf, jpg, jpeg</FileInfoLi>
                  <FileInfoLi>Supported name format : name_year</FileInfoLi>
                </ULTagElement>
              </Flex>
            </div>
            <RightSection>
              {!presentationFile && (
                <Uploader
                  setFile={setPresentationFile}
                  isDefault={!presentationFile}
                  fileName={
                    corporateData?.name?.toLowerCase().replace(/\s/g, '') +
                    '_presentation' +
                    '_' +
                    getYear(presentationFile?.date)
                  }
                  defaultButtonTrigger={
                    <Button.Secondary
                      icon={<UploadIcon />}
                      text="Upload File"
                      height="32px"
                    />
                  }
                />
              )}

              {presentationFile ? (
                <DocumentFlex alignCenter>
                  {!!presentationFile?.url && (
                    <Popover
                      getPopupContainer={() =>
                        document.getElementById(`presentationFile`)
                      }
                      content={<PopoverImg src={presentationFile?.url} />}
                      trigger="hover"
                    >
                      <PreviewDiv id={'presentationFile'}>
                        <EyeIcon />
                      </PreviewDiv>
                    </Popover>
                  )}
                  <Uploader
                    isDelete={true}
                    file={presentationFile}
                    setFile={setPresentationFile}
                    isDefault={presentationFile}
                    fileName={
                      corporateData?.name?.toLowerCase().replace(/\s/g, '') +
                      '_presentation' +
                      '_' +
                      getYear(presentationFile?.date)
                    }
                    defaultButtonTrigger={
                      <Button.Primary text="Change File" height="32px" />
                    }
                  />
                  <Button.Secondary
                    text="Remove"
                    onClick={() => setPresentationFile(null)}
                    height={'32px'}
                    width="76px"
                  />
                </DocumentFlex>
              ) : null}
            </RightSection>
          </CommonFlex>

          <CommonFlex spaceBetween alignCenter>
            <SubTitleDiv>Corporate Video Link</SubTitleDiv>
            <RightSection>
              <Input
                placeholder="Eg. www.youtube.com/results?search_query=about+iim"
                width="100%"
                suffix={
                  <CopyLinkDiv
                    onClick={() =>
                      copyText(settingsForm.getFieldValue('corporateVideoLink'))
                    }
                  >
                    <LinkIcon />
                  </CopyLinkDiv>
                }
                name="corporateVideoLink"
                // type='url'
              />
            </RightSection>
          </CommonFlex>
        </MainWrapper>

        <Divider />
        <MainWrapper marginBottom="100px">
          <Flex spaceBetween>
            <ComanyDiv>Social Media</ComanyDiv>
            {mediaOptions?.filter(
              item =>
                !socialMediaList
                  ?.map(data => data?.media)
                  ?.includes(item?.value)
            )?.length ? (
              <AddMediaButton
                onClick={() => setAddMediaDrawer(true)}
                text={<AddLinkspan>Add More Link</AddLinkspan>}
                icon={<AddBlueIcon />}
              />
            ) : null}
          </Flex>

          {socialMediaList?.length ? (
            socialMediaList?.map((item, index) => (
              <CommonFlex spaceBetween key={index + item?.link} alignCenter>
                <SubTitleDiv>{item?.media}</SubTitleDiv>
                <RightSection>
                  <Input
                    defaultValue={item?.link}
                    name={item?.media + index}
                    type="url"
                    placeholder="https://www.website.com"
                    width="100%"
                    suffix={
                      <CopyLinkDiv onClick={() => copyText(item?.link)}>
                        <LinkIcon />
                      </CopyLinkDiv>
                    }
                    onChange={({ target }) =>
                      onLinkChange(target?.value, index)
                    }
                  />
                </RightSection>
              </CommonFlex>
            ))
          ) : (
            <NoDataDiv>
              <Empty description="No media links" />
            </NoDataDiv>
          )}
        </MainWrapper>
      </Container>

      <AddMediaLinksDrawer
        addMediaDrawer={addMediaDrawer}
        setAddMediaDrawer={setAddMediaDrawer}
        socialMediaList={socialMediaList}
        setSocialMediaList={setSocialMediaList}
        onChangeFormFields={onChangeFormFields}
        mediaOptions={mediaOptions}
      />
    </>
  )
}

export default AddtionalInfo
